import { Modal } from 'antd';
import {Table} from 'antd'
import React  from 'react'

function showApiError(error) {

    let alertMessage = ""
    if (typeof error == "string") {
      alertMessage = error
    } else {
      if (error.error !== undefined) {
        alertMessage = error.error 
      } else {
        alertMessage = error.message
      }
      
  }
  Modal.error({
    title: 'Error',
    content: alertMessage
  } )
}


function showApiSuccess(message, onOk) {

  Modal.success({
    title: 'Success',
    content: message,
    onOk: onOk 
  })
}


function renderFooterTable(total, columns, titleCol, size) {
  const dataList = [{
    [titleCol]: "Total",
    total,
    key: "total"
  }];
  return (
    <Table
      className="footer"
      pagination={false}
      size={size}
      showHeader={false}
      columns={columns}
      rowClassName={"footer"}
      dataSource={dataList}
    />
  );
}


export {
  showApiError, showApiSuccess, renderFooterTable
}